<template>
  <div
    class="flex text-sm text-blue align-center margin-left"
    style="float: left; height: 100%;"
  >
    <div
      class="flex-sub flex text-sm text-blue align-center contact-way"
      :style="{
        visibility: $route.path === '/dashboard' ? 'visible' : 'hidden',
      }"
    >
      <div class="text-cut">
        <span>{{ $t('dashboard.accountMnager') }}:{{ salesUser }}</span>
      </div>
      <div v-if="'' != salesPhone" class="text-cut">
        <span>TEL：{{ salesPhone }}</span>
      </div>
      <div v-if="'' != salesQQ" class="text-cut">
        <span>QQ：{{ salesQQ }}</span>
      </div>
      <div class="text-cut">
        <span>{{ $t('dashboard.saleAssistantName') }}:{{ saleAssistantName }}</span>
      </div>
      <div v-if="'' != saleAssistantPhone" class="text-cut">
        <span>TEL：{{ saleAssistantPhone }}</span>
      </div>
      <div class="text-cut">
        <span>{{ $t('dashboard.serviceManager') }}:{{ customerUser }}</span>
      </div>
      <div class="text-cut">
        <span>TEL：{{ customerPhone }}</span>
      </div>
      <div v-if="'' != customerQQ" class="text-cut">
        <span>QQ：{{ customerQQ }}</span>
      </div>
      <div class="text-cut">
        <a href="http://www.jiufanglogistics.cn/index" target="_blank">
          {{ $t('dashboard.website') }}
        </a>
      </div>
      <div class="margin-left text-green" v-if="siteData.hwcLink">
        <a :href="siteData.hwcLink" target="_blank">
          {{ $t('dashboard.abroadSystem') }}
        </a>
      </div>
      <div v-if="redirect_to_old_system" class="margin-left text-red">
        <span>
          2023年7月15日起,宁波九方切换新系统,历史订单请点击旧系统查看
        </span>
      </div>
    </div>
    <div v-if="redirect_to_old_system" class="margin-left text-orange">
      <a @click="jumpToNb">旧系统 </a>
    </div>
  </div>
</template>

<script>
import { getCustomerSalesmanService } from '@/api/myProfile'
import { getNbToken } from '@/api/user'
import {
		mapGetters
	} from 'vuex'
export default {
  computed: {
    ...mapGetters(['siteData']),
  },
  data() {
    return {
      salesUser: '',
      salesPhone: '',
      salesQQ: '',
      saleAssistantName: '',
      saleAssistantPhone: '',
      customerUser: '',
      customerPhone: '',
      customerQQ: '',
      redirect_to_old_system: false,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      const data = await getCustomerSalesmanService({})
      // this.userMap = this.publicData.userAll
      if (
        data.salesmanUser &&
        data.salesmanUser !== null &&
        data.customerServiceUser &&
        data.customerServiceUser !== null
      ) {
        this.salesUser = data.salesmanUser.name
        this.salesPhone = data.salesmanUser.phone
        this.salesQQ = data.salesmanUser.qq

        this.customerUser = data.customerServiceUser.name
        this.customerPhone = data.customerServiceUser.phone
        this.customerQQ = data.customerServiceUser.qq

        this.showInfo = true
        this.redirect_to_old_system = data.redirect_to_old_system
      }
      if (data.saleAssistantUser && data.saleAssistantUser !== null) {
        this.saleAssistantName = data.saleAssistantUser.name;
        this.saleAssistantPhone = data.saleAssistantUser.phone
      }
    },
    async jumpToNb() {
      this.$store.dispatch('app/toggleDialog', true)
      let { code, data, message } = await getNbToken()
      this.$store.dispatch('app/toggleDialog', false)
      // if(code!=200){
      //   return this.$message.error(message)
      // }
      console.log(process.env.VUE_APP_NB_OLD_CLIENT_URI)
      let url =
        process.env.VUE_APP_NB_OLD_CLIENT_URI +
        `#/dashboard?origin=nbClient&originToken=${data}`
      window.open(url, 'blank')
    },
  },
}
</script>

<style scoped>
.text-orange a:hover {
  color: #f37b1d;
  text-decoration: none;
}
.text-red {
  color: red;
  text-decoration: none;
}
.contact-way >div{
  margin-left: 50px;
}
</style>
